import React from "react";
import {
  HomeOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  LogoutOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Button, Layout, Menu, theme } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { authService } from "../services/auth.service";

const { Content, Sider } = Layout;

const items: MenuProps["items"] = [
  {
    key: "/",
    icon: React.createElement(HomeOutlined),
    label: "Home",
  },
  {
    key: "/ownership",
    icon: React.createElement(KeyOutlined),
    label: "Ownership",
  },
  {
    key: "/kol",
    icon: React.createElement(TeamOutlined),
    label: "KOL",
  },
  {
    key: "/session",
    icon: React.createElement(ClockCircleOutlined),
    label: "Session",
  },
];

const DashboardLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const {
    token: { colorBgContainer, borderRadiusLG, colorPrimary },
  } = theme.useToken();

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Layout style={{ minHeight: "100vh", padding: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "end",
            gap: "4px",
            color: colorPrimary,
          }}
        >
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>NoteFun</div>
          <div style={{ fontSize: "16px", color: "gray", marginBottom: "2px" }}>
            Admin
          </div>
        </div>

        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={() => authService.logout()}
        >
          Logout
        </Button>
      </div>
      <Layout
        style={{
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
          padding: "8px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Sider
          style={{ background: colorBgContainer, fontWeight: "500" }}
          width={200}
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: "100%" }}
            items={items}
            onClick={({ key }) => navigate(key)}
          />
        </Sider>
        <Content
          style={{
            padding: "0 24px",
            minHeight: 280,
            height: "calc(100vh - 84px)",
            overflowY: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
